export default function maxTranslate() {
  return -this.snapGrid[this.snapGrid.length - 1];
}


//////////////////
// WEBPACK FOOTER
// ./~/swiper/esm/components/core/translate/maxTranslate.js
// module id = 1191
// module chunks = 168